import * as React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { householdAction } from "../../actions/household.action";
import Link from "react-router-dom/es/Link";
import Loading from "../../components/Loading/Loading";
import DoubleArrowRight from "../../components/Icons/DoubleArrowRight";
import { appAction } from "../../actions/app.action";
import sp500Monthly from "../../assets/gspc-20071231-20090228-monthly.json";
import sp500Daily from "../../assets/gspc-20071201-20090228.json";
import statementSampleDealer from "../../assets/statement-dealer-logo.svg";
import CurrencyNumber from "../../components/UI/CurrencyNumber";
import PercentageNumber from "../../components/UI/PercentageNumber";
import CyRiskChart from "../../components/Charts/CyRiskChart";
import moment from "moment";
import { CSSTransition } from "react-transition-group";
import envelopFront from "../../assets/envelop-front.png";
import envelopBack from "../../assets/envelop-back.png";
import envelopBase from "../../assets/envelop-base.png";
import envelopBg from "../../assets/envelop-bg.png";
import "../../animation.scss";
import SectionHeader from "../../components/UI/SectionHeader";
import SectionCaption from "../../components/UI/SectionCaption";
import SpComparison from "../../components/UI/SpComparison";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide/Slide";
import SeeImportantDisclosures from "../../components/UI/SeeImportantDisclosures";

const animationSpeed = 5000;
const styles = (theme) => ({
  contentWrapper: {
    height: "100%",
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  contentCaption: {
    marginBottom: 10,
  },
  summaryContentCaption: {
    marginBottom: 10,
    marginLeft: 40,
  },
  graphCaption: {
    marginBottom: 10,
    textAlign: "center",
  },
  wrapper: {
    height: "100%",
  },
  content: {
    opacity: 1,
    pointerEvents: "all",
    "&.hidden": {
      opacity: 0,
      height: 0,
      pointerEvents: "none",
    },
  },
  componentTitle: {
    position: "relative",
    "& > *": {
      position: "absolute",
      width: "100%",
      top: 0,
      opacity: 1,
      pointerEvents: "all",
      transition: theme.transitions.create("opacity", {
        easing: theme.transitions.easing.easeIn,
        duration: 300,
      }),
      "&.hidden": {
        opacity: 0,
        pointerEvents: "none",
      },
    },
  },
  envelopWrapper: {
    width: "100%",
    minHeight: 440,
    padding: 10,
    bottom:
      theme.wbiComponent.riskComponent.riskSimCta.height +
      theme.wbiComponent.riskComponent.riskSimChart.height,
    height: `calc(100% - ${theme.wbiComponent.riskComponent.riskSimChart.height}px - ${theme.wbiComponent.riskComponent.riskSimCta.height}px - 80px)`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    [theme.breakpoints.down("xl")]: {
      maxHeight: `calc(100% - ${
        theme.wbiComponent.cyContainer.basePadding * 2
      }px)`,
    },
    "& > div": {
      position: "relative",
      maxWidth: 600,
      maxHeight: `calc(100%)`,
      width: "70%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      overflow: "hidden",
    },
  },
  envelopInsert: {
    background: `linear-gradient(-136deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[200]} 100%)`,
    boxShadow: `-2px 8px 3px 0 rgba(0,0,0,0.05)`,
    width: "100%",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      height: "45%",
    },
    maxHeight: 480,
    padding: 20,
    zIndex: 1,
  },
  envelopBack: {
    background: `url(${envelopBack}) center bottom / 100% auto no-repeat`,
    height: "100%",
  },
  envelopFront: {
    background: `url(${envelopFront}) center bottom / 100% auto no-repeat`,
    height: "100%",
  },
  envelopBase: {
    background: `url(${envelopBase}) center top / 100% auto no-repeat`,
    height: "100%",
    "& > div": {
      position: "absolute",
      top: -242,
      left: 0,
      right: 0,
    },
  },
  envelopBg: {
    background: `url(${envelopBg}) center top / 100% auto no-repeat`,
    height: "100%",
    "& > div": {
      position: "absolute",
      top: -242,
      left: 0,
      right: 0,
    },
  },
  statementRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 10,
    [theme.breakpoints.down("md")]: {
      marginBottom: 5,
    },
    "& h1": {
      [theme.breakpoints.down("md")]: {
        fontSize: 19,
      },
    },
  },
  statementValue: {
    marginBottom: 14,
    [theme.breakpoints.down("md")]: {
      marginBottom: 4,
    },
    textAlign: "center",
    "& h1": {
      marginBottom: 4,
      [theme.breakpoints.down("md")]: {
        fontSize: 18,
      },
    },
    "& span": {
      color: theme.palette.error.main,
      fontWeight: 500,
      fontSize: 18,
      padding: "0 10px",
      [theme.breakpoints.down("md")]: {
        fontSize: "17px !important",
      },
    },
    "& .positive": {
      color: theme.palette.primary.main,
    },
    "& .showDivider": {
      borderRight: "2px solid #003D79",
    },
  },
  statementHeader: {
    textAlign: "right",
    borderTop: "4px solid #003D79",
    paddingTop: 10,
    minWidth: "58%",
    "& h1": {
      [theme.breakpoints.down("md")]: {
        fontSize: 18,
      },
    },
  },
  innerWrapper: {
    width: "100%",
    zIndex: 19,
    maxHeight: 200,
  },
  riskChartWrapper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    // zIndex: 19,
    height: 280,
  },
  riskChartContainer: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  riskChartSubContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  riskChartYLabel: {
    marginRight: "4px",
    width: "4.06%",
    [theme.breakpoints.down("md")]: {
      writingMode: "vertical-rl",
    },
  },
  riskChart: {
    width: "95.94%",
    position: "relative",
    backgroundSize: "100% 39.77px",
    backgroundImage: `linear-gradient(to right, transparent 1px, transparent 1px), linear-gradient(to bottom,  ${theme.palette.grey["A200"]}  1px, transparent 1px)`,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    height: theme.wbiComponent.riskComponent.riskSimChart.height,
    backgroundColor: theme.palette.grey[50],
    boxShadow:
      "0 1rem 2rem 0 rgba(255,255,255,0.11), 0 0.5rem 1rem 0 rgba(0,0,0,0.08)",
  },
  chartMask: {
    position: "absolute",
    backgroundSize: "100% 39.77px",
    backgroundImage: `linear-gradient(to right, transparent 1px, transparent 1px), linear-gradient(to bottom,  ${theme.palette.grey["A200"]}  1px, transparent 1px)`,
    height: "100%",
    top: 0,
    backgroundColor: theme.palette.grey[50],
    transition: theme.transitions.create("width", {
      easing: "linear",
      duration: animationSpeed,
    }),
  },
  riskControl: {
    position: "absolute",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      bottom: "115px",
    },
  },
  simulatorControl: {
    background: theme.palette.primary.main,
    border: "none",
    color: theme.palette.common.white,
    fontSize: 16,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      height: 0,
    },
    textAlign: "center",
    minWidth: 90,
    height: 40,
    cursor: "pointer",
    padding: "0px 20px",
    "&.running": {
      background: theme.palette.error.main,
    },
  },
  lossSummaryChart: {
    height: `calc(100% - 300px)`,
    width: "100%",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "& tspan": {
      [theme.breakpoints.down("md")]: {
        fontSize: 12,
      },
    },
  },
  lossSummary: {
    position: "absolute",
    width: "100%",
    height: 240,
    bottom: 20,
    left: 0,
    display: "flex",
    paddingTop: 20,
    flexDirection: "column",
    justifyContent: "space-between",
    "& > div": {
      textAlign: "center",
      paddingBottom: 40,
    },
    "& aside": {
      [theme.breakpoints.down("md")]: {
        fontSize: "16px !important",
      },
    },
  },
  lossSummaryDetails: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > div": {
      padding: 30,
    },
  },
  controller: {
    width: theme.wbiComponent.ctaController.totalWidth,
    [theme.breakpoints.down("md")]: {
      width: "45px",
    },
    height: "100%",
    position: "fixed",
    right: 0,
    top: 0,
    zIndex: 0,
    background: `linear-gradient(-189deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 94%)`,
    boxShadow: "inset 0 0 17px rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      height: 360,
      width: "100%",
      background: "transparent",
      // background: 'linear-gradient(-12deg, #FAA42F 45%, #FCCD8C 68%)',
      // boxShadow: '0 0 6px 0 rgba(0,0,0,0.20)',
      cursor: "pointer",
      border: "none",
    },
    "@media print": {
      display: "none",
    },
  },
  saveButtonNavItem: {
    width: theme.wbiComponent.staticNavigation.totalWidth,
    left: 0,
    textTransform: "uppercase",
    color: theme.palette.grey[50],
    fontSize: 14,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
    "& svg": {
      [theme.breakpoints.down("md")]: {
        width: "18px",
      },
    },
  },
  modalContentText: {
    fontSize: 16,
    color: theme.palette.grey[800],
    [theme.breakpoints.down("md")]: {
      lineHeight: 1.3,
    },
  },
  startBtn: {
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class Risk extends React.Component {
  current = 0;
  initial500 = 1484.459961;
  initialInvestmentForDemoView = 1000000;

  state = {
    saved: false,
    open: true,
    currentAccount: 0,
    simRunning: false,
    simTimePerData: animationSpeed, // in ms
    simCurrentIndex: 0,
    simCurrentMonth: sp500Monthly[0].Date,
    riskTolerance: 0,
    in: false,
    animating: {
      duration: 500,
      debug: false,
      front: null,
      back: null,
      insert: null,
      chart: null,
    },
    panicPoint: {
      Close: null,
      Date: null,
    },
    postSimAdjustment: false,
    simulatorView: true,
  };

  onUpdate = (panicPoint) => {
    let rt = (panicPoint.Close - this.initial500) / this.initial500;
    this.setState({
      panicPoint: panicPoint,
      riskTolerance: rt,
      postSimAdjustment: true,
    });
  };

  computeCurrentAccount = (dateIndex, initialAccount) => {
    if (dateIndex < sp500Monthly.length) {
      let rt =
        (sp500Monthly[dateIndex].Close - this.initial500) / this.initial500;
      let closeData = (rt + 1) * initialAccount;
      this.setState(
        {
          currentAccount: closeData,
          simCurrentIndex: dateIndex + 1,
          riskTolerance: rt,
        },
        () => {
          this.current++;
          // console.log(sp500Monthly[dateIndex]);
          // console.log({current: this.state.currentAccount, risk: this.state.riskTolerance});
        }
      );
    } else {
      console.log("Sim End at the End of timeline");
      clearInterval(this.timerFn);
      if (!this.props.demoMode) {
        this.props.dispatch(
          householdAction.saveHouseholdMetadata(this.props.householdId, {
            risk: this.state.riskTolerance,
            panicPoint: sp500Monthly[this.state.simCurrentIndex - 1],
          })
        );
      }
    }
  };

  handleSimulator = (status) => {
    const { simTimePerData } = this.state;
    const { demoMode } = this.props;
    // Setting the risk value for the first month
    if (status)
      this.computeCurrentAccount(
        this.current,
        demoMode
          ? this.initialInvestmentForDemoView
          : this.props.currentHousehold.initialInvestment
      );
    this.setState({
      simRunning: status,
    });

    if (status && this.current < sp500Monthly.length) {
      this.timerFn = setInterval(() => {
        this.computeCurrentAccount(
          this.current,
          demoMode
            ? this.initialInvestmentForDemoView
            : this.props.currentHousehold.initialInvestment
        );
      }, simTimePerData);
    } else {
      clearInterval(this.timerFn);
      this.setState({
        panicPoint: sp500Monthly[this.state.simCurrentIndex - 1],
        simulatorView: false,
      });
    }
  };

  saveAdjustment = () => {
    this.props.dispatch(
      householdAction.saveHouseholdMetadata(this.props.householdId, {
        risk: this.state.riskTolerance,
        panicPoint: this.state.panicPoint,
      })
    );
    this.setState({ saved: true });
  };

  handleModalClose = () => {
    this.setState({ open: false }, () => {
      setTimeout(() => {
        this.toggleAnimationState();
      }, 500);
    });
  };

  goToNextStep(householdId) {
    this.props.history.push(`/Portal/household/${householdId}/rroreturn`);
  }

  toggleAnimationState = () => {
    this.setState({ in: !this.state.in });
  };

  renderNextButton() {
    const { postSimAdjustment } = this.state;
    const { classes, currentHousehold, demoMode } = this.props;
    if (demoMode) {
      return null;
    }
    if (currentHousehold.risk !== 0) {
      if (postSimAdjustment) {
        return (
          <button
            className={classes.saveButtonNavItem}
            onClick={this.saveAdjustment}
          >
            Save
            <DoubleArrowRight />
          </button>
        );
      } else {
        return (
          <Link to={`/Portal/household/${this.props.householdId}/rroreturn`}>
            <button className={classes.saveButtonNavItem}>
              Save
              <DoubleArrowRight />
            </button>
          </Link>
        );
      }
    }
  }

  renderEnvelopInsert(initialInvestment) {
    const { classes, currentHousehold } = this.props;
    const { currentAccount, simCurrentIndex } = this.state;
    const delta = currentAccount - initialInvestment;

    return (
      <div className={classes.envelopInsert}>
        <div className={classes.statementRow}>
          <img src={statementSampleDealer} alt={"Dealer Logo"} />
          <div
            className={classes.statementHeader}
            style={{ textAlign: "right" }}
          >
            <Typography variant="h5" color="textPrimary">
              Investment Statement
            </Typography>
            {simCurrentIndex > 0 ? (
              <Typography variant={"body1"}>
                {moment(sp500Monthly[simCurrentIndex - 1].Date)
                  .startOf("month")
                  .format("MMMM Do")}
                -
                {moment(sp500Monthly[simCurrentIndex - 1].Date)
                  .endOf("month")
                  .format("MMMM Do")}
              </Typography>
            ) : (
              <Typography variant={"body1"}>
                {moment("2007-12-01").format("MMMM Do")}-
                {moment("2007-12-31").format("MMMM Do")}
              </Typography>
            )}
          </div>
        </div>
        <div className={classes.statementRow}>
          {currentHousehold && (
            <Typography variant="h5" color="textPrimary">
              {currentHousehold.Clients[0].profile.firstName}
              {currentHousehold.Clients.length > 1 && (
                <React.Fragment>
                  {" "}
                  and{" "}
                  <span>{currentHousehold.Clients[1].profile.firstName}</span>
                </React.Fragment>
              )}
            </Typography>
          )}
          <Typography variant={"subtitle2"}>
            Initial Account Value <CurrencyNumber value={initialInvestment} />
          </Typography>
        </div>
        <div className={classes.statementValue}>
          <Typography variant="h5" color="textPrimary">
            Current Account Value
          </Typography>
          <span
            className={`${delta >= 0 ? "positive" : ""}`}
            style={{ fontSize: 22 }}
          >
            <CurrencyNumber value={currentAccount} />
          </span>
        </div>
        <div className={classes.statementValue}>
          <Typography variant="h5" color="textPrimary">
            Change
          </Typography>
          <span className={`showDivider ${delta >= 0 ? "positive" : ""}`}>
            <CurrencyNumber showSign={true} value={delta} />
          </span>
          <span className={`${delta >= 0 ? "positive" : ""}`}>
            <PercentageNumber
              showSign={true}
              value={delta / initialInvestment}
            />
          </span>
        </div>
      </div>
    );
  }

  componentDidMount() {
    // Initialize state
    this.current = 0;

    const { householdId, currentHousehold, demoMode } = this.props;

    if (demoMode) {
      this.setState({ currentAccount: this.initialInvestmentForDemoView });
    } else {
      if (
        currentHousehold === null ||
        (currentHousehold.hasOwnProperty("id") &&
          String(currentHousehold.id) !== householdId)
      ) {
        this.props.dispatch(householdAction.getHouseholdById(householdId));
      } else {
        this.setState({ currentAccount: currentHousehold.initialInvestment });
      }
    }

    this.props.dispatch(appAction.toggleMainNav(false));
    if (demoMode) {
      this.props.dispatch(appAction.setEducationNav(true));
    } else {
      this.props.dispatch(appAction.setAddClientNav(true));
    }
    this.props.dispatch(appAction.updateProgressStep(2));
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { currentHousehold, currentHouseholdLoading } = this.props;

    if (
      this.state.saved &&
      currentHouseholdLoading &&
      !nextProps.currentHouseholdLoading
    ) {
      this.goToNextStep(currentHousehold.id);
    }
    if (!currentHousehold && nextProps.currentHousehold) {
      if (this.state.currentAccount === 0) {
        this.setState({
          currentAccount: nextProps.currentHousehold.initialInvestment,
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.simRunning &&
      !this.state.simRunning &&
      this.state.simCurrentIndex > 0 &&
      !this.props.currentHouseholdLoading
    ) {
      console.log("Sim End");
      clearInterval(this.timerFn);
      if (!this.props.demoMode) {
        this.setState({ simulatorView: false });
        this.props.dispatch(
          householdAction.saveHouseholdMetadata(this.props.householdId, {
            risk: this.state.riskTolerance,
            panicPoint: sp500Monthly[this.state.simCurrentIndex - 1],
          })
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.dispatch(appAction.setEducationNav(false));
  }

  render() {
    const {
      classes,
      currentHousehold,
      currentHouseholdLoading,
      theme,
      demoMode,
    } = this.props;
    const { simRunning, simCurrentIndex } = this.state;

    if (
      (!currentHousehold || currentHouseholdLoading || !currentHousehold) &&
      demoMode === undefined
    ) {
      return <Loading />;
    }

    let risk, initialInvestment, panicPoint, simulatorView;
    if (demoMode) {
      risk = this.state.riskTolerance;
      initialInvestment = this.initialInvestmentForDemoView;
      panicPoint = this.state.panicPoint;
      simulatorView = this.state.simulatorView;
    } else {
      risk = currentHousehold.risk;
      initialInvestment = currentHousehold.initialInvestment;
      panicPoint = currentHousehold.panicPoint;
      simulatorView = currentHousehold.risk === 0;
    }

    return (
      <div className={classes.contentWrapper}>
        <SectionHeader text={"Loss Tolerance"} />
        {simulatorView && (
          <Dialog
            open={this.state.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              Loss Tolerance
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-slide-description"
                className={classes.modalContentText}
              >
                The foundation of Cy’s process is built to help investors
                by identifying their loss and return profile. We believe getting
                your loss tolerance right is the single most important factor in
                helping you achieve your investment goals. It starts here.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                className={classes.startBtn}
                onClick={this.handleModalClose}
                variant="contained"
                size="small"
                color="primary"
              >
                Let's Start
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {simulatorView && (
          <SectionCaption>
            To help you identify your loss tolerance, let’s simulate the effects
            of an actual market cycle on your account value.
          </SectionCaption>
        )}
        <div
          className={`${classes.wrapper} ${classes.content} ${
            simulatorView ? "" : "hidden"
          }`}
        >
          {this.state.animating.debug && (
            <button
              onClick={this.toggleAnimationState}
              style={{ position: "fixed", bottom: 100, right: 100, zIndex: 99 }}
            >
              {!this.state.in ? "Enter" : "Exit"} Transition
            </button>
          )}
          <Grid
            className={classes.wrapper}
            container
            space={24}
            justify="space-between"
            alignItems="center"
            direction="column"
            wrap="nowrap"
          >
            <Grid item xs={12}>
              <Grid
                className={classes.wrapper}
                container
                justify="center"
                alignItems="center"
              >
                <div className="envelop">
                  <CSSTransition
                    in={this.state.in}
                    timeout={1000}
                    classNames="base"
                  >
                    {(state) => (
                      <React.Fragment>
                        <div className="base">
                          <div className={classes.envelopBase}>
                            <div
                              className={`baseFront baseFront-${state} ${classes.envelopFront}`}
                            />
                          </div>
                        </div>
                        <CSSTransition
                          in={state === "entered"}
                          timeout={500}
                          classNames="front"
                          mountOnEnter
                          unmountOnExit
                          onEntered={() => {
                            this.setState({
                              animating: { front: "entered" },
                            });
                          }}
                        >
                          <div className="front">
                            <div className={classes.envelopFront} />
                          </div>
                        </CSSTransition>
                        <CSSTransition
                          in={this.state.animating.front === "entered"}
                          timeout={500}
                          classNames="back"
                          exit={false}
                          onEntered={() => {
                            this.setState({
                              animating: { back: "entered" },
                            });
                          }}
                        >
                          <div className="back">
                            <div className={classes.envelopBack} />
                          </div>
                        </CSSTransition>
                        <CSSTransition
                          in={this.state.animating.back === "entered"}
                          timeout={1500}
                          classNames="insert"
                          exit={false}
                          onEntered={() => {
                            this.setState({
                              animating: { insert: "entered" },
                            });
                          }}
                        >
                          <div className="insert">
                            {this.renderEnvelopInsert(initialInvestment)}
                          </div>
                        </CSSTransition>
                      </React.Fragment>
                    )}
                  </CSSTransition>
                </div>
              </Grid>
            </Grid>
            <div className={classes.riskChartWrapper}>
              <CSSTransition
                in={this.state.animating.insert === "entered"}
                timeout={1000}
                classNames="chart"
                exit={false}
                onEntered={() => {
                  this.setState({
                    animating: { chart: "entered" },
                  });
                }}
              >
                <div className="chart chart-transition">
                  <div className={classes.riskChartContainer}>
                    <div className={classes.riskChartSubContainer}>
                      <Typography
                        className={classes.riskChartYLabel}
                        variant={"caption"}
                      >
                        VALUE
                      </Typography>
                      <div className={classes.riskChart}>
                        <CyRiskChart
                          data={sp500Daily}
                          height={
                            theme.wbiComponent.riskComponent.riskSimChart.height
                          }
                          simplified={true}
                        />
                        <div
                          className={classes.chartMask}
                          style={{
                            width:
                              (1 - simCurrentIndex / sp500Monthly.length) *
                                100 +
                              "%",
                          }}
                        />
                      </div>
                    </div>
                    <Typography variant={"caption"} style={{ marginLeft: 62 }}>
                      TIME
                    </Typography>
                  </div>
                  <div className={classes.riskControl}>
                    <Button
                      className={`${classes.simulatorControl} ${
                        simRunning ? "running" : ""
                      }`}
                      onClick={this.handleSimulator.bind(
                        this,
                        !this.state.simRunning
                      )}
                    >
                      {simRunning ? "STOP" : "START"}
                    </Button>
                  </div>
                </div>
              </CSSTransition>
            </div>
            <SeeImportantDisclosures
              style={{ width: 180, textAlign: "right", right: 0 }}
            />
          </Grid>
        </div>

        <div className={`${classes.content} ${simulatorView ? "hidden" : ""}`}>
          {panicPoint && (
            <div>
              <div className={classes.lossSummaryChart}>
                <Typography variant={"body2"} className={classes.graphCaption}>
                  S&P 500 Index vs. Time
                </Typography>
                <CyRiskChart
                  data={sp500Daily}
                  simplified={false}
                  height={340}
                  highlight={panicPoint}
                  onUpdate={this.onUpdate}
                />
              </div>

              <div className={classes.lossSummary}>
                <SectionCaption>
                  Your hypothetical investment portfolio just simulated the
                  impact of actual market fluctuations in the S&amp;P 500 Index
                  between 2007 and 2009. Based on your reaction to the
                  simulator, Cy has estimated the amount of loss you
                  would be able to tolerate.
                </SectionCaption>
                <div className={classes.lossSummaryDetails}>
                  {this.state.panicPoint.Close === null ? (
                    <React.Fragment>
                      <div>
                        <SpComparison
                          label={"Your Loss Tolerance"}
                          data={{ type: "percentage", value: risk }}
                          showSign={true}
                          subscript={""}
                        />
                      </div>
                      <div>
                        <SpComparison
                          label={"Your Loss Amount"}
                          data={{
                            type: "currency",
                            value: initialInvestment * risk,
                          }}
                          showSign={true}
                          subscript={""}
                        />
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div>
                        <SpComparison
                          label={"Your Loss Tolerance"}
                          data={{
                            type: "percentage",
                            value: this.state.riskTolerance,
                          }}
                          showSign={true}
                          subscript={""}
                        />
                      </div>
                      <div>
                        <SpComparison
                          label={"Your Loss Amount"}
                          data={{
                            type: "currency",
                            value: initialInvestment * this.state.riskTolerance,
                          }}
                          showSign={true}
                          subscript={""}
                        />
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        {!demoMode && (
          <div className={classes.controller}>{this.renderNextButton()}</div>
        )}
      </div>
    );
  }
}

Risk.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  currentHousehold: PropTypes.object,
  currentHouseholdLoading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  return {
    householdId: ownProps.match.params.householdId,
    currentHouseholdLoading: state.household.currentHouseholdLoading,
    currentHousehold: state.household.currentHousehold,
    user: state.user,
    appName: state.app.appName,
  };
};

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(Risk)
);



// WEBPACK FOOTER //
// ./src/containers/PortfolioRisk/index.jsx